import { formatDurationMinutes as formatDurationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatDurationProps = {
    minutes: number;
}

export const formatDurationMinutes = ({ minutes }: FormatDurationProps): string =>
    formatDurationDiagram(minutes);
